<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="820">
    <v-card>
        <v-toolbar color="secondary" dark dense>
           <v-icon left>mdi-sync</v-icon> BORROWED HISTORY
            <v-spacer/>
             <v-icon @click="emitToParent('close')">mdi-close</v-icon>
        </v-toolbar>
        <v-card-text>
            <v-row class="mt-4" no-gutters dense>
                  <span>
                   <v-icon left small>mdi-account</v-icon>  {{borrowed.trade_name}}
                  </span>
                    <v-spacer/>
                    <span  style="width: 150px; ">
                            <v-select
                            v-model="search"
                            label="Filter"
                            solo
                            hide-details
                            :items="['', 'Borrowed', 'Returned']"
                            dense  
                ></v-select>
                    </span>
            </v-row>
            <v-data-table
                class="va-table mt-2 mb-10"
                dense
                :search="search"
                :headers="headers"
                disable-sort
                hide-default-footer
                :items="borroweds"
                >
                <template v-slot:body="{ items }">
                    <tbody>
                    <tr v-for="(item,index) in items" :key="index + 'k'">
                        <td :class="STATUS_TEXT(item.type)">{{item.type}}</td>
                        <td>{{item.invoice}}</td>
                        <td>{{item.delivered_date | moment($date_format)}}</td>
                        <td>{{item.product_code}}</td>
                        <td>{{item.quantity}}</td>
                         <td class="text-right">{{$money(item.amount)}}</td>
                    </tr>
                    </tbody>
                </template>
            </v-data-table>
                 Summary
                <v-card class="pa-2">
                <div   v-for="(data, i) in borrowed.borrowed_data" :key="'b-'+ i" class="sm-font _borrow_data">
                    <span>Code: {{data.product_code}}</span>
                    <span>Borrowed: {{data.borrowed}}</span>
                    <span>Returned: {{data.returned}}</span>
                    <span>Returnable: {{data.returnable}}</span>
                      <span>Value: {{$money($IsNum(data.unit_price) * $IsNum(data.returnable)) }}</span>
                </div> 
                </v-card>
         </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    data: () => ({
      borroweds:[],
      search:'',
      item:{},
        headers:[
          {text:"Type", value:'type'},
          {text:"Reference Invoice"},
          {text:"Date"},
          {text:"Code"},
          {text:"Qty"},
          {text:"Value", align:"right"}
        ]
    }),
  props: {
    show: {
        type: Boolean,
        default: false
    },
    borrowed: {
        type: Object,
        default: ()=>{}
    }
  },
  watch:{
      show(val) {
          if(val){
            this.search = ''
            this.getItems()
          }
      }
  },
  computed:{
    TOTAL(){
        var total = this.borroweds.reduce((res,item)=>res+=this.$IsNum(item.unit_price) * this.$IsNum(item.quantity),0)
        return total
    }
  },
  methods: {
    emitToParent () {
      this.$emit('DialogEvent', "")
    },
    getItems(){
         this.$http.post("borrow/history", {customer_id:this.borrowed.customer_id}).then(response => {
              response.data.items !=null?this.borroweds = response.data.items : this.borroweds=[]
              }).catch(e => {
              console.log(e.data)
          })
    }
  }
}
</script>
